import React from "react";
import { getUserDetails } from "../core/storage/localStorage";
import { Redirect } from "react-router-dom";

function AdminGuard({ children }) {
  const user = getUserDetails();
  if (user.role !== "Admin") {
    return <Redirect to="/" />;
  }
  return <>{children}</>;
}

export default AdminGuard;
